module.exports = __webpack_public_path__ + "static/lotus-img-39d57e92c989913eb47f6f45e185071b.png";